"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitlementsService = exports.AuthorizationType = void 0;
const logger_1 = require("@linq/logger");
const Request_1 = require("./Request");
const RequestUtil_1 = require("./RequestUtil");
const Forbidden_1 = require("./HttpErrors/Forbidden");
const STAGE = process.env.STAGE;
const ENTITLEMENTS_HOST = STAGE === 'sandbox' ? 'http://localhost:4010/sandbox' : process.env.ENTITLEMENTS_HOST;
var AuthorizationType;
(function (AuthorizationType) {
    AuthorizationType[AuthorizationType["Individual"] = 0] = "Individual";
    AuthorizationType[AuthorizationType["Role"] = 1] = "Role";
})(AuthorizationType = exports.AuthorizationType || (exports.AuthorizationType = {}));
class EntitlementsService {
    constructor() {
        this.request = new Request_1.Request({ baseUrl: ENTITLEMENTS_HOST });
    }
    async addAuthorization(source, resourceType, resourceId, metadata) {
        const payload = RequestUtil_1.RequestUtil.getTokenPayload();
        const authorization = {
            resourceId,
            metadata,
            source,
            type: resourceType,
            principalId: payload.sub,
        };
        return this.post(authorization);
    }
    async addResourceOwnedAuthorizations(source, resourceType, resourceIds, owningResource, metadata) {
        const authorization = {
            resourceIds,
            metadata,
            source,
            type: resourceType,
            principalId: owningResource,
        };
        return this.post(authorization);
    }
    async post(authorization) {
        const response = await this.request.post('/entitlements/authorization', authorization, {
            headers: RequestUtil_1.RequestUtil.getHeaders(),
        });
        return response.data;
    }
    async delete(source, resourceId, principalId) {
        const url = `/entitlements/authorization/${source}/${resourceId}`;
        await this.request.delete(url, { principalId }, { headers: RequestUtil_1.RequestUtil.getHeaders() });
    }
    async patch(source, resourceId, metadata) {
        const url = `/entitlements/authorization/${source}/${resourceId}`;
        await this.request.patch(url, { metadata }, {
            headers: RequestUtil_1.RequestUtil.getHeaders(),
        });
    }
    async getAuthorization(source, resourceType, type) {
        const payload = RequestUtil_1.RequestUtil.getTokenPayload();
        if (!payload) {
            throw new Forbidden_1.Forbidden({ message: 'no token payload' });
        }
        const principal = type === AuthorizationType.Role ? payload.role : payload.sub;
        return this.requestAuthorization(source, principal, resourceType);
    }
    async requestAuthorization(source, principalId, resourceType) {
        const url = `/entitlements/authorization`;
        const response = await this.request.get(url, {
            headers: RequestUtil_1.RequestUtil.getHeaders(),
            params: {
                source,
                resourceType,
                principalId,
            },
        });
        logger_1.Logger.debug('Authorization => ', response.data);
        return response.data;
    }
}
exports.EntitlementsService = EntitlementsService;
//# sourceMappingURL=EntitlementsService.js.map